/**
 * CarregandoAxiom — o ÚNICO carregamento de tela cheia / painel do AxiomGO.
 *
 * Só o logo do topo (AxiomLogoTopo), 64 px, na cor do texto do tema, pulsando
 * (`pulso`, 1.4 s). Nenhum texto visível: o leitor de tela recebe o `aria-label`
 * (já traduzido por quem chama) em `role="status"`. Com `prefers-reduced-motion`
 * o logo fica parado e inteiro.
 *
 * Spinner inline de botão/campo NÃO usa isto.
 */
import { AxiomLogoTopo } from '@/components/icons/AxiomLogoTopo'
import { cn } from '@/lib/utils'

type CarregandoAxiomProps = {
  /** Texto para leitor de tela, já traduzido (i18n). */
  label: string
  /** Classes do contêiner (ex.: `h-screen bg-axg-bg`). */
  className?: string
  /** Lado do logo em px. Padrão 64. */
  size?: number
}

export function CarregandoAxiom({ label, className, size = 64 }: CarregandoAxiomProps) {
  return (
    <div
      role="status"
      aria-label={label}
      data-testid="carregando-axiom"
      className={cn('flex flex-1 items-center justify-center', className)}
      style={{ color: 'var(--axg-text-primary)' }}
    >
      <AxiomLogoTopo
        size={size}
        aria-hidden="true"
        focusable="false"
        className="animate-pulso motion-reduce:animate-none"
      />
    </div>
  )
}
